import { apiUrl } from "../config/api";

export async function listClientDocuments(clientId, includeNotVisible) {
  let params = {
    clientId: clientId,
    includeNotVisible: includeNotVisible,
  };

  let url = apiUrl('GetClientDocuments')

  return sendReq(params, url);
}

export async function notifyBulkDocumentUpload(params) {
  let url = apiUrl('NotifyBulkDocumentUpload')

  return sendReq(params, url);
}

async function sendReq(params, url) {
  let res = await fetch(url, { method: "POST", body: JSON.stringify(params) });
  return res.json();
}
